import React, { useState, useEffect } from "react";
import styles from "./ProjectsPanel.module.css";
import commonStyle from "../common.module.css";
import { PROJECT_COLUMNS, PROJECT_COLUMNS_REAL } from "../../Values/tables";
import { connect, useDispatch } from "react-redux";

import Loading from "../../Components/Loading/Loading";

import ApiTopBar from "../../Components/TopBar/ApiTopBar";
import ApiCustomTable from "../../Components/CustomTable/ApiCustomTable";
import NewImportProjectModal from "../../Components/Modals/ImportModal/NewImportProjectModal";
import DeleteProjectSelectedModal from "../../Components/Modals/DeleteSelectedModal/DeleteProjectSelectedModal";
import {themeColors} from "../../Components/theme";
import PopUpBox from "../AuditLogs/PopUpBox";
import { fetchProjectsMongo, fetchProjectsFilterValues } from "../../Services/projects";
import { googleAnalytics } from "../../Services/users";
import {
  setCurrentRoute
} from '../../Redux/actions';
import { useLocation } from 'react-router-dom';
import HtmlBanner from "../../bannerManagement/baneerComp";




const Project = ({ history, user, organizationUsers,theme,searchString, organizationData,authToken, filterObject, filterSort }: any) => {
  const dispatcher = useDispatch();
  const [projectsList, setProjectsList] = useState<any[] | undefined>(
    undefined
  );
  const [tasksImportModal, setTasksImportModal] = useState(false);
  const [notesImportModal, setNotesImportModal] = useState(false);
  const [callLogsImportModal, setCallLogsImportModal] = useState(false);
  const [lastPage, setLastPage] = useState(-1);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [searchQuery, setsearchQuery] = useState("");
  const [columnModal, setColumnModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [showImportModal, setShowImportModal] = useState(false);
  const [load, setLoad] = useState(false);
  const [owner, setOwner] = useState(false);
  const [deletePopup, setDeletePopop] = useState(false);
  const [auditLog, setAuditLog] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [count, setCount] = useState<any>(0);
  const [isGACalled, setIsGACalled] = useState<any>(false);

      const [cRoute,setCRoute]=useState("")
    
          const location = useLocation();
    
      useEffect(() => {
        dispatcher(setCurrentRoute(location.pathname))
        setCRoute(location.pathname)
      }, [location]);


  useEffect(() => {
    if (user.organization_id) {
      fetchProjectsMongo(user.organization_id,  (data) => setFilterData(data), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished);
    }
  }, [user]);

  useEffect(() => {
    setIsFinished(false);
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    if (authToken) {
      fetchProjectsMongo(user.organization_id,  (data) => setFilterData(data), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished, false, pageSize, 1, false);
    }
  }, [filterObject, filterSort, searchQuery]);

  useEffect(() => {
    if (
      filterData &&
      filterData.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if (authToken) {
          fetchProjectsMongo(user.organization_id,  (data) => setFilterData(data), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished, false, pageSize);
        }
      } else {
        if (authToken) {
          fetchProjectsMongo(user.organization_id,  (data) => setFilterData(data), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished, true, pageSize);
        }
      }
    }
  }, [page, pageSize]);

  useEffect(() => {
    fetchProjectsFilterValues(user.organization_id, authToken, dispatcher);
  }, [user])

  useEffect(() => {
    if (selectedRows.length > 0) {
      setOwner(true);
    } else if (selectedRows.length === 0) {
      setOwner(false);
    }
  }, [selectedRows]);

  const clearSelectedRowsData = () => {
    setSelectedRowsData([]);
    setSelectedRows([]);
  };
  // let isFinished = false;

  const exportFile = () => {
    let data: any[] = [];
    if (selectedRowsData.length !== 0) {
      selectedRowsData.forEach((item) => {
        const user = organizationUsers.find((user: { uid: any; }) => user.uid === item.created_by);
        data.push({
          Name: item.project_name,
          "Project Status":item?.project_status,
          "Developer Name": item.developer_name,
          "Address": item.address,
          "Rera Link": item.rera_link,
          "Walkthrough Link": item.walkthrough_link,
          "Property Type": item.property_type,
          Status: item.status,
          "Created By": user ? user.user_email : item.created_by,
          // Profile: item.profile,
          // "Project Id": item.project_id,
          // "Project image": item.project_image,
          "Unit No":item.unit_no,
          "Type":item.type,
          "Current Owner":item.owner_name,
          "Owner Contact":item.owner_contact_no,
          "Price":item.price,
        });
      });
    }
    return data;
  };
const containerStyles = {backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
useEffect(()=>{
  if(isGACalled === false){
    if(user?.uid && user?.profile){
      setIsGACalled(true)
      googleAnalytics('Listings_Screen',user)
    }
  }
},[user])

    const [isHardRefresh, setIsHardRefresh] = useState(false);
  
  useEffect(() => {
    const navEntries:any = performance.getEntriesByType('navigation');
    if (navEntries.length > 0 && navEntries[0].type === 'reload') {
      setIsHardRefresh(true);
    }
  }, []);

  return (
    <>
     <div className={styles.parent} style={{display:"block",marginTop:"0px",...containerStyles}}>
      {load === true && <Loading />}
       {cRoute&& isHardRefresh&&( <div className={styles.PbContainer}>
        <HtmlBanner   user={user} route={cRoute} bannerType={"pageBanner"}/>
      </div>)}
      <div className={commonStyle.topBar} style={{marginTop:"0px",...containerStyles}}>
      <ApiTopBar
          history={history}
          title={"Add Listing"}
          path={"/addProjects"}
          owner={owner}
          deleteSelected={() => {
            setDeletePopop(true);
          }}
          onClick={() => {
            setShowImportModal(true);
          }}
          onChange={(val) => setsearchQuery(val)}
          filterText={"Status"}
          setColumnModal={(data) => setColumnModal(data)}
          show={true}
          showStatusBox={true}
          onExport={exportFile}
          onCallLogsImport={() => {
            setCallLogsImportModal(true);
          }}
          onNotesImport={() => {
            setNotesImportModal(true);
          }}
          onTasksImport={() => {
            setTasksImportModal(true);
          }}
          searchedString={searchString}
          selectedRows={selectedRows}
          setAuditLog={setAuditLog}
          isOtpVerified={isOtpVerified}
          panel = "projects"
        />
      </div>
      <div className={commonStyle.parent} style={{minHeight:"450px",...containerStyles}}>
         {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")?
        <ApiCustomTable
        tableColumns={PROJECT_COLUMNS_REAL}
        tableRows={filterData}
        selectedRows={selectedRows}
        setSelectedRows={(data) => setSelectedRows(data)}
        tableType="projects"
        showColumnModal={columnModal}
        hideColumnModal={() => setColumnModal(false)}
        selectedRowsData={selectedRowsData}
        setSelectedRowsData={(data) => setSelectedRowsData(data)}
        // setSearchedItem={(val) => setsearchQuery(val)}
        setApiModal={(data) => {}}
        setApiEdit={(data) => {}}
        setApiData={(data) => {}}
        setPage={(val) => setPage(val)}
        setPageSize={(val) => setPageSize(val)}
        callApi={() => Promise.resolve()}
        pageSize={pageSize}
        page={page}
        isFinished={isFinished}
        totalCount={count}
        lastPage={lastPage}
      />
        
        :
        <ApiCustomTable
        tableColumns={PROJECT_COLUMNS}
        tableRows={filterData}
        selectedRows={selectedRows}
        setSelectedRows={(data) => setSelectedRows(data)}
        tableType="projects"
        showColumnModal={columnModal}
        hideColumnModal={() => setColumnModal(false)}
        selectedRowsData={selectedRowsData}
        setSelectedRowsData={(data) => setSelectedRowsData(data)}
        // setSearchedItem={(val) => setsearchQuery(val)}
        setApiModal={(data) => {}}
        setApiEdit={(data) => {}}
        setApiData={(data) => {}}
        setPage={(val) => setPage(val)}
        setPageSize={(val) => setPageSize(val)}
        callApi={() => Promise.resolve()}
        pageSize={pageSize}
        page={page}
        isFinished={isFinished}
        totalCount={count}
        lastPage={lastPage}
      />
        }
      </div>
      {showImportModal && (
        <NewImportProjectModal
          open={showImportModal}
          close={() => setShowImportModal(false)}
          organization_id={user.organization_id}
          history={history}
          usersList={organizationUsers}
          user={user}
        />
      )}

      {deletePopup && (
        <DeleteProjectSelectedModal
          data={selectedRowsData}
          clearSelectedRowsData={clearSelectedRowsData}
          open={deletePopup}
          totalData={projectsList}
          organization_id={user.organization_id}
          close={() => {
            setDeletePopop(false);
          }}
          panel="projects"
          selectedRows={selectedRows}
        />
      )}
      {auditLog && (
              <PopUpBox
              open={auditLog}
              close={() => setAuditLog(false)}
              setIsOtpVerified={setIsOtpVerified}
              setAuditLog={setAuditLog}
              onExport={exportFile}
              selectedRows={selectedRows}
              panel = "projects"
              />)}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    organizationUsers: state.organizationUsers.data,
    theme: state.theme.isLightMode,
    searchString: state.searchItem.projectSearchString,
    organizationData: state.organization.organizationData,
    filterObject: state.projectsFilter,
    filterSort: state.projectsSort,
    authToken: state.user.authToken,
  };
};

export default connect(mapStateToProps)(Project);